import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppConstant } from '../app.constants';
import { SiteLayoutService } from './sitelayout.service';
import { LoaderService } from '../shared/services/loader.service';
import { CommonLookupData } from '../shared/commonHelper/common.service';
import { IResponse } from '../../app/programs/Models/response.model';
import { HttpCallService } from '../shared/services/base.service';
import { Observable } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import * as powerbiClient from 'powerbi-client';
import { MsalService } from '@azure/msal-angular';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-sitelayout',
  templateUrl: './sitelayout.component.html',
  styleUrls: ['./sitelayout.component.css']
})
export class SitelayoutComponent implements OnInit {
  showHide: boolean;
  showHideUserPref: boolean;
  className: string;
  userName: string;
  selectedProgramId: string = "";
  userAccess: number = 0;
  userProgramDatasource: any = [];
  userDetail: any;
  currentYear: string;
  subMenuStyle: boolean = false;
  subAdminMenuStyle: boolean = false;
  subMarkerMenuStyle: boolean = false;
  subResourceMenuStyle: boolean = false


  subInsightMenus: any = [];
  subAdminMenus: any = [];
  private AccessToken: string = "";
  private ReportId: string = "";
  private tileId: string = "";
  private ReportGroupId: string = "";
  private reportUrl: string = "";
  private reportType: string = "";
  public reportHeight: number = window.innerHeight - 192;
  public IsPowerBIReport: boolean = true;
  public DashboardReportUrl: string = "";
  public currentMenuLink: string = "";
  public currentMainMenuLink: string = "";

  constructor(private _router: Router, 
    private authService: MsalService,
    public appConstant: AppConstant,
    private _siteLayoutService: SiteLayoutService,
    private _loaderService: LoaderService,
    private _toasterService: ToastrService,
    public _commonServiceHelper: CommonLookupData,
    private _dataService: HttpCallService,
    private sanitizer: DomSanitizer,
    private router: Router
  ) {
    this.showHideUserPref = false;
    this.className = 'user-welcome dropdown';
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (document.getElementById('liprogramheader') && document.getElementById('liprogramheader').contains(event.target)) {
      this.showHideUserDropdown();
    } else {
      this.className = 'user-welcome dropdown';
    }
  }
  inventoryMenus = [{
    className: 'icon-02',
    name: "Mobile Users",
    moduleCode: "MIMS_MobileUsers",
    link: "/mims/mimsusers",
    refId: '1',
    dispayOrder: 1,
  }, {
    className: 'icon-17',
    name: "Mobile Roles",
    moduleCode: "MIMS_MobileRoles",
    link: "/mims/roles",
    dispayOrder: 2,
    refId: '2',
  }, {
    className: 'icon-10',
    name: "Shipments",
    moduleCode: "MIMS_Shipments",
    link: "/mims/shipments",
    dispayOrder: 3,
    refId: '3',
  }, {
    className: 'icon-11',
    name: "Decantings",
    moduleCode: "MIMS_Decantings",
    link: "/mims/decantings",
    dispayOrder: 4,
    refId: '4',
  }, {
    className: 'icon-12',
    name: "Dispatch",
    moduleCode: "MIMS_Dispatch",
    link: "/mims/dispatchlist",
    dispayOrder: 5,
    refId: '5',
  }, {
    className: 'icon-13',
    name: "Container Disposals",
    moduleCode: "MIMS_ContainerDisposals",
    link: "/mims/disposals",
    refId: '6',
    dispayOrder: 6,
  }, {
    className: 'icon-14',
    name: "Locker Access",
    moduleCode: "MIMS_LockerAccess",
    link: "/mims/lockers",
    refId: '7',
    dispayOrder: 7,
  },
  {
    className: 'icon-16',
    name: "Inventory Checks",
    moduleCode: "MIMS_InventoryChecks",
    link: "/mims/inventories",
    refId: '8',
    dispayOrder: 8,
  },
  {
    className: 'icon-15',
    name: "Resources",
    moduleCode: "MIMS_Resources",
    refId: '9',
    link: "/mims/resources",
    dispayOrder: 11,
  },
  {
    className: 'icon-18',
    name: "Marking Operation",
    refId: '10',
    moduleCode: "MIMS_MarkingOperations",
    link: "/mims/markingoperations",
    dispayOrder: 9,
  },
  {
    className: 'icon-19',
    name: "Marking Field Test",
    refId: '11',
    moduleCode: "MIMS_MarkingFieldTests",
    link: "/mims/fieldtests",
    dispayOrder: 10,
  },
  {
    className: 'icon-20',
    name: "App Settings",
    moduleCode: "MIMS_App_Setting",
    refId: '9124',
    link: "/mims/app-setting",
    dispayOrder: 11,
  }];
  GetMarkerInventory() {
    if (this.appConstant.userModuleAccessDatasource) {
      let checkMIMSaccess = this.appConstant.userModuleAccessDatasource.find(x => x.moduleCode === "MIMS_MarkerInventory" || x.parentModuleCode === "MIMS_MarkerInventory" );
      this.appConstant.subMarkerInventoryMenus = this.appConstant.userModuleAccessDatasource.filter(x => {
        if (x.parentModuleCode === "MIMS_MarkerInventory") {
          var objDetail = this.inventoryMenus.find(c => c.moduleCode === x.moduleCode);
          if (objDetail) {
            x.className = objDetail.className;
            x.link = objDetail.link;
            if (x.moduleName) {
              x.name = x.moduleName;
            } else {
              x.name = objDetail.name;
            }
            x.refId = x.moduleID;
            x.dispayOrder = objDetail.dispayOrder;
            return x;
          }
        }
      });
      if (checkMIMSaccess && this.appConstant.programId && this.appConstant.subMarkerInventoryMenus && this.appConstant.subMarkerInventoryMenus.length <= 0 && this.appConstant.userDetail.roleContext === this.appConstant.roleContext.Admin) {
        this.appConstant.subMarkerInventoryMenus = this.inventoryMenus;
      }
      if (this.appConstant.subMarkerInventoryMenus) {
        this.appConstant.subMarkerInventoryMenus = this.appConstant.subMarkerInventoryMenus.sort((n1, n2) => {
          if (n1.dispayOrder > n2.dispayOrder) {
            return 1;
          }
          if (n1.dispayOrder < n2.dispayOrder) {
            return -1;
          }
          return 0;
        });
      }
      if (checkMIMSaccess) {
        this.getAppSettings();
      }
    }
  }
  ngOnInit() {
    this.userName = this.authService.instance.getAllAccounts()[0].username;
    console.log("bef init");
    localStorage.removeItem("isRunningUserDetailsCall");
    if (!localStorage.getItem('isRunningUserDetailsCall')) {
      this.getUserDetails();
    }
    this.currentYear = new Date().getFullYear().toString();
    if (this.appConstant && this.appConstant.programId && (this.appConstant.logInAsProgramContext || (this.appConstant.userDetail && this.appConstant.userDetail.roleContext != this.appConstant.roleContext.Admin))) {
      this.GetInsightMenu();
      this.GetAdminMenu();
    }
    //this.GetResources();
  };

  GetInsightMenu() {
    this.appConstant.mainInsightMenu = {};
    this.subInsightMenus = [];
    this._siteLayoutService.GetInsightMenu(this.appConstant.MENU_IDENTIFIER.insightMenu)
      .pipe(
      finalize(() => {
        this._loaderService.display(false);
      }))
      .subscribe(
        (res: any) => {
          if (res && res.data) {
            var mainMenu = res.data.filter(x => x.isParent);
            var subMenus = res.data.filter(x => !x.isParent);
            var IsProgramAdmin = this.appConstant.userProgramDatasource.filter(x => x.programID == this.appConstant.programId);
            if (this.appConstant.userDetail.roleContext == this.appConstant.roleContext.Admin || this.appConstant.isUserProgramAdmin || (IsProgramAdmin != null && IsProgramAdmin.length > 0 && IsProgramAdmin[0].isUserProgramAdmin)) {
              this.subInsightMenus = subMenus;
              this.appConstant.mainInsightMenu = mainMenu[0];
            } else {
              if (mainMenu && mainMenu.length > 0 && mainMenu[0].roles && mainMenu[0].roles.length > 0) {
                var mainMenuRole = mainMenu[0].roles.filter(x => x.value === this.appConstant.userModuleAccessDatasource[0].roleName);
                if (mainMenuRole && mainMenuRole.length > 0) {
                  this.appConstant.mainInsightMenu = mainMenu[0];
                }
                subMenus.forEach(element => {
                  var submenuRole = element.roles.filter(x => x.value === this.appConstant.userModuleAccessDatasource[0].roleName);
                  if (submenuRole && submenuRole.length > 0) {
                    this.subInsightMenus.push(element);
                  }
                });
              }
            }
            if (this.subInsightMenus != null && this.subInsightMenus.length > 0) {
              this.subInsightMenus.sort((a, b) => 0 - (a.displayOrder > b.displayOrder ? -1 : 1));
            }
          }
        },
        (error: any) => {
          this._toasterService.error(error.message, 'Error');
        }
      );
  };

  GetAdminMenu() {
    this.appConstant.adminMenu = {};
    this.subAdminMenus = [];
    this._siteLayoutService.GetInsightMenu(this.appConstant.MENU_IDENTIFIER.adminMenu)
      .pipe(
      finalize(() => {
        this._loaderService.display(false);
      }))
      .subscribe(
        (res: any) => {
          if (res && res.data) {

            var mainMenu = res.data.filter(x => x.isParent);
            var subMenus = res.data.filter(x => !x.isParent);
            var IsProgramAdmin = this.appConstant.userProgramDatasource.filter(x => x.programID == this.appConstant.programId);
            if (this.appConstant.userDetail.roleContext == this.appConstant.roleContext.Admin || this.appConstant.isUserProgramAdmin || (IsProgramAdmin != null && IsProgramAdmin.length > 0 && IsProgramAdmin[0].isUserProgramAdmin)) {
              this.subAdminMenus = subMenus;
              this.appConstant.adminMenu = mainMenu[0];
            } else {
              if (mainMenu && mainMenu.length > 0 && mainMenu[0].roles != null && mainMenu[0].roles.length > 0) {
                var mainMenuRole = mainMenu[0].roles.filter(x => x.value === this.appConstant.userModuleAccessDatasource[0].roleName);
                if (mainMenuRole && mainMenuRole.length > 0) {
                  this.appConstant.adminMenu = mainMenu[0];
                }
                subMenus.forEach(element => {
                  var submenuRole = element.roles.filter(x => x.value === this.appConstant.userModuleAccessDatasource[0].roleName);
                  if (submenuRole && submenuRole.length > 0) {
                    this.subAdminMenus.push(element);
                  }
                });
              }
            }
            if (this.subAdminMenus != null && this.subAdminMenus.length > 0) {
              this.subAdminMenus.sort((a, b) => 0 - (a.displayOrder > b.displayOrder ? -1 : 1));
            }
          }
        },
        (error: any) => {
          this._toasterService.error(error.message, 'Error');
        }
      );
  };

  OtherMenuClick() {
    this.subMenuStyle = false;
    this.subAdminMenuStyle = false;
    this.currentMainMenuLink = "";
    this.currentMenuLink = "";
  }

  OpenSubMenu() {
    if (this.subMenuStyle == false) {
      this.subMenuStyle = true;
      this.subAdminMenuStyle = false;
    } else {
      this.subMenuStyle = false;
    }
    this.currentMainMenuLink = this.appConstant.mainInsightMenu.refId;
    this.appConstant.loadInsightMenu = true;
    if (this.router.url == "/insight-menu") {
      this.LoadDashoardReport(this.appConstant.mainInsightMenu);
    }
    else {
      this.router.navigate(['/insight-menu']);
    }


  };
  OpenMIMSResourceMenu() {
    if (this.subResourceMenuStyle == false) {
      this.subResourceMenuStyle = true;
    } else {
      this.subResourceMenuStyle = false;
    }
  }
  OpenMIMSMenu() {
    if (this.subMarkerMenuStyle == false) {
      this.subMarkerMenuStyle = true;
      this.subMenuStyle = false;
    } else {
      this.subMarkerMenuStyle = false;
    }
  }
  OpenSubAdminMenu() {
    if (this.subAdminMenuStyle == false) {
      this.subAdminMenuStyle = true;
      this.subMenuStyle = false;
    } else {
      this.subAdminMenuStyle = false;
    }
    this.currentMainMenuLink = this.appConstant.adminMenu.refId;
    this.appConstant.loadInsightMenu = false;

    if (this.router.url == "/insight-menu") {
      this.LoadDashoardReport(this.appConstant.adminMenu);
    }
    else {
      this.router.navigate(['/insight-menu']);
    }
  }
  //LoadMarker
  LoadDashoardReport(submenu) {
    this.currentMenuLink = submenu.refId;
    this._commonServiceHelper.GetToken((accessToken: any) => {
      if (accessToken != false) {
        this.AccessToken = accessToken;
        this.getUserDashboardReport(submenu);
      } else {
        this._toasterService.error("Something went wrong, Please contact technical support or administration.", 'Error');
      }
    });
  };
  LoadMarkerUrl(submenu) {
    this.router.navigate([submenu.link])
  }


  getUserDashboardReport(submenu) {
    if (submenu) {
      this.appConstant.isReport = submenu.isReport;
      if (submenu.isReport && this.CheckReportUrl(submenu.url)) {
        this.showReports();
      }
      else {
        this.appConstant.insightMenusafeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(submenu.url);
      }
    }
  };

  showReports() {
    this.reportHeight = window.innerHeight - 221;
    const config: powerbiClient.IEmbedConfiguration = {
      type: this.reportType,
      accessToken: this.AccessToken,
      embedUrl: this.reportUrl,
      uniqueId: this.ReportId,
      permissions: powerbiClient.models.Permissions.All,
      viewMode: powerbiClient.models.ViewMode.View,
      pageView: 'actualSize',
      id: this.tileId,
      dashboardId: this.ReportId,
      settings: { filterPaneEnabled: true, navContentPaneEnabled: true }
    };

    let myDiv1 = document.getElementById('userReportsContainer');
    if (myDiv1 != null) {
      const powerbi = new powerbiClient.service.Service(
        powerbiClient.factories.hpmFactory,
        powerbiClient.factories.wpmpFactory,
        powerbiClient.factories.routerFactory
      );
      powerbi.reset(myDiv1);
      powerbi.embed(myDiv1, config);
    }
  };

  CheckReportUrl(url: string) {
    if (url) {
      var urlArray = url.split('/');
      if (urlArray.length >= 7 && urlArray[4] && urlArray[6]) {
        this.ReportId = urlArray[6].toString();
        this.ReportGroupId = urlArray[4].toString();
        if (urlArray[7] == "tiles") {
          this.reportType = "tile";
          this.tileId = urlArray[8].toString();
          this.reportUrl = this.appConstant.powerbiTileURl + this.ReportId + '&tileId=' + urlArray[8].toString() + '&groupId=' + this.ReportGroupId;
        }
        else if (urlArray[5] == "dashboards") {
          this.tileId = '';
          this.reportType = this.appConstant.powerBiDashboard;
          this.reportUrl = this.appConstant.powerbiDashboardURl + this.ReportId + '&groupId=' + this.ReportGroupId;
        }
        else if (urlArray[5] == "reports") {
          this.tileId = '';
          this.reportType = this.appConstant.powerBiReport;
          this.reportUrl = this.appConstant.powerbiReportURl + this.ReportId + '&groupId=' + this.ReportGroupId;
        }
        return true;
      } else {
        this._toasterService.error("PowerBI URL not in proper format.", 'Error');
        return false;
      }
    } else {
      return false;
    }
  };
  getUserDetails() {
    if (this.userName) {
      if (localStorage.getItem('userDetail') == null || localStorage.getItem('userDetail') == "null") {
        if (localStorage.getItem('isRunningUserDetailsCall')) {
          localStorage.removeItem("isRunningUserDetailsCall");
        } else {
          localStorage.setItem('isRunningUserDetailsCall', "true");
          this.appConstant.isUserAuthorizeCallCompleted = false;
          this._loaderService.display(true);
          //Get User Details
          this.GetUserDetail(this.userName)
            .pipe(
      finalize(() => {
              localStorage.removeItem("isRunningUserDetailsCall");
              this._loaderService.display(false);
              this.appConstant.isUserAuthorizeCallCompleted = true;
            }))
            .subscribe((data) => {
              if (data && data.data && data.data.userId) {
                localStorage.setItem('userDetail', JSON.stringify(data.data));
                this.userDetail = data.data;
                this.appConstant.userDetail = data.data;
                setTimeout(() => {
                  window.location.reload();
                }, 100);

              } else {
                this.UnAuthorizedUser();
              }
            },
              (error: any) => {
                this.UnAuthorizedUser();
              });
        }
      }
    }
    if (localStorage.getItem('userDetail') != null) {
      this.userDetail = localStorage.getItem('userDetail') ? JSON.parse(localStorage.getItem('userDetail')) : null;
      this.appConstant.userDetail = this.userDetail;
      this.appConstant.isUserAuthorizeCallCompleted = true;
      console.log("without call");
      this.pageOnload();
    }
  };

  GetUserDetail(data?: string): Observable<IResponse> {
    const apiURL = this.appConstant.APIUrl + 'User/Get/';
    return this._dataService.get<IResponse>(apiURL + data);
  };

  UnAuthorizedUser() {
    console.log("un");
    localStorage.setItem('userDetail', null);
    this.pageOnload();
    console.log("un after");
  }

  pageOnload() {
    console.log("init");
    if (localStorage.getItem('userDetail') && this.appConstant.userDetail) {
      this.userName = this.appConstant.userDetail.firstName + ' ' + this.appConstant.userDetail.lastName;
      if (localStorage.getItem('logInAsProgramContext')) {
        var data = JSON.parse(localStorage.getItem('logInAsProgramContext'));
        this.appConstant.logInAsProgramContext = true;
        this.appConstant.programId = data.programId;
        if (this.appConstant.userDetail.roleContext == this.appConstant.roleContext.Admin) {
          this.getLogInAsProgramContextModuleAccess();
          this.getProgramDetaSource();
          this.subMenuStyle = false;
          this.GetInsightMenu();
          this.GetAdminMenu();
        }
        else {
          this.getUserModuleAccess(this.appConstant.programId, true);
          console.log("get pro");
        }
      }
      else if (this.appConstant.userDetail.roleContext != this.appConstant.roleContext.Admin && this.appConstant.userProgramDatasource && this.appConstant.userProgramDatasource.length == 0) {
        this.getUserProgramDetails();
      }
      else {
        this.userAccess = 2;
        if (this._router && this._router.url != "/dashboard") {
          this._router.navigate(['/dashboard']);
        }
      }
    } else {
      this.userProgramDatasource = this.appConstant.userProgramDatasource;
      this.userAccess = 1;
    }
  };

  logout() {
    localStorage.clear();
    this.authService.logout();
  }

  navShowHide() {
    this.showHide = !this.showHide;
    if (this.showHide) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }
  }

  showHideUserDropdown() {
    this.showHideUserPref = !this.showHideUserPref;
    if (this.showHideUserPref) {
      this.className = 'user-welcome dropdown open';
    } else {
      this.className = 'user-welcome dropdown';
    }
  }

  onResize(event) {
    if (window.innerWidth < 960)
      document.body.classList.add('menu-open');
  }

  getUserProgramDetails() {
    this._loaderService.display(true);
    this._siteLayoutService.getUserProgramDetails()
      .pipe(
      finalize(() => {
        this._loaderService.display(false);
      }))
      .subscribe(
        (res: any) => {
          if (res && res.data) {
            //this.appConstant.userProgramDatasource = res.data;
            this.appConstant.userProgramDatasource = res.data.filter(x => x.isProgramUserActive).sort(this.alphabetizeProgramList);
            if (this.appConstant.userProgramDatasource.length == 1) {
              this.getUserModuleAccess(this.appConstant.userProgramDatasource[0].programID);
              this.userProgramDatasource = this.appConstant.userProgramDatasource;
            } else {
              this.userProgramDatasource = this.appConstant.userProgramDatasource;
              this.userAccess = 1;
            }
          }
        },
        (error: any) => {
          this._toasterService.error(error.message, 'Error');
        }
      );
  };

  alphabetizeProgramList(a, b) {
    // Use toUpperCase() to ignore character casing
    const programA = a.name.toUpperCase();
    const programB = b.name.toUpperCase();

    let comparison = 0;
    if (programA > programB) {
      comparison = 1;
    } else if (programA < programB) {
      comparison = -1;
    }
    return comparison;
  }

  getUserModuleAccess(programId: string, loadUserProgram = false) {
    this.appConstant.programId = programId;
    this.appConstant.selectedProgramId = programId;
    let matchObj = this.appConstant.userProgramDatasource.find(x => x.programID === programId);
    this.appConstant.selectedHeaderProgramText = matchObj ? matchObj.name : "";
    this._loaderService.display(true);
    this._siteLayoutService.getUserModuleAccess()
      .pipe(
      finalize(() => {
        this._loaderService.display(false);
      }))
      .subscribe(
        (res: any) => {
          if (res && res.data) {
            this.GetInsightMenu();
            this.GetAdminMenu();
            this.appConstant.userModuleAccessDatasource = res.data;
            this.GetMarkerInventory();
            
            if (this._router && this._router.url != "/dashboard") {
              this._router.navigate(['/dashboard']);
            }
			if (this.appConstant.userProgramDatasource.length == 0 && loadUserProgram) {
              this.getUserProgramDetails();
            } else {
              this.userAccess = 2;
            }
          }
        },
        (error: any) => {
          this._toasterService.error(error.message, 'Error');
        }
      );
  };

  programSelectionClick() {
    if (this.selectedProgramId) {
      let matchObj = this.userProgramDatasource.find(x => x.programID === this.selectedProgramId);
      this.appConstant.selectedHeaderProgramText = matchObj ? matchObj.name : "";
      this.getUserModuleAccess(this.selectedProgramId);
    }
  };

  getLogInAsProgramContextModuleAccess() {
    this._loaderService.display(true);
    this._siteLayoutService.getLogInAsProgramContextModuleAccess(this.appConstant.programId)
      .pipe(
      finalize(() => {
        this._loaderService.display(false);
      }))
      .subscribe(
        (res: any) => {
          if (res && res.isSuccess) {
            var obj = [];
            res.data.forEach(element => {
              if (element.isActive) {
                obj.push({
                  moduleID: element.moduleId,
                  moduleName: element.moduleName,
                  moduleCode: (element.moduleCode?element.moduleCode:element.moduleName),
                  roleName: "",
                  action: 15,
                  view: true,
                  add: true,
                  edit: true,
                  delete: true
                });
              }
            });
            this.appConstant.userModuleAccessDatasource = obj;
            this.appConstant.selectedProgramId = this.appConstant.programId;
            //debugger;
            this.GetMarkerInventory();
            this.userAccess = 2;
            if (this._router && this._router.url != "/dashboard") {
              this._router.navigate(['/dashboard']);
            }
          }
        },
        (error: any) => {
          this._toasterService.error(error.message, 'Error');
        }
      );
  };

  getProgramDetaSource() {
    this._loaderService.display(true);
    this._siteLayoutService.getProgramDataSource()
      .pipe(
      finalize(() => {
        this._loaderService.display(false);
      }))
      .subscribe(
        (res: any) => {
          if (res && res.isSuccess) {
            var obj = [];
            res.data.forEach(element => {
              if (this.appConstant.programId.toLocaleLowerCase() == element.recordId)
                this.appConstant.selectedHeaderProgramText = element.value;
              obj.push({
                programID: element.recordId,
                name: element.value,
                programRoleID: "",
                programRoleName: "",
                userID: "",
                isUserProgramAdmin: true
              });
            });
            this.appConstant.userProgramDatasource = obj;
          }
        },
        (error: any) => {
          this._toasterService.error(error.message, 'Error');
        }
      );
  };

  backToAdmin() {
    this._commonServiceHelper.customConfirm('Are you sure you want to go admin screen? Any unsaved changes will be lost.', (result: any) => {
      if (result) {
        this.appConstant.programId = '';
        this.appConstant.selectedProgramId = '';
        this.appConstant.selectedHeaderProgramText = '';
        this.appConstant.userModuleAccessDatasource = [];
        this.appConstant.userProgramDatasource = [];
        this.appConstant.logInAsProgramContext = false;
        localStorage.removeItem('logInAsProgramContext');
        if (this._router && this._router.url != "/dashboard") {
          this._router.navigate(['/dashboard']);
        } else {
          this.appConstant.ShowAdminDashboard = null;
          this.appConstant.ShowAdminDashboard = this.appConstant.userDetail.roleContext == this.appConstant.roleContext.Admin && this.appConstant.logInAsProgramContext == false;
        }
      }
    });
  };

  changeOfRoutes() {
    var data = localStorage.getItem('logInAsProgramContext') ? JSON.parse(localStorage.getItem('logInAsProgramContext')) : null;
    if (data == null && this.appConstant.programId && this.appConstant.userDetail.roleContext == this.appConstant.roleContext.Admin && this.appConstant.logInAsProgramContext) {
      data = { logInAsProgramContext: this.appConstant.logInAsProgramContext, programId: this.appConstant.programId };
      localStorage.setItem('logInAsProgramContext', JSON.stringify(data));
    }
    if (!data && this.appConstant.logInAsProgramContext) {
      this.backToAdmin();
    } else if (data && this.appConstant.logInAsProgramContext == false) {
      this.pageOnload();
    } else if (data && this.appConstant.logInAsProgramContext && data.programId != this.appConstant.programId) {
      if (this.appConstant.programId) {
        data.programId = this.appConstant.programId;
        localStorage.setItem('logInAsProgramContext', JSON.stringify(data));
      }
       this.pageOnload();
    }
  };

  headerProgramChange(programId: string, name: string) {
    if (programId && name && this.appConstant.programId != programId) {
      this._commonServiceHelper.customConfirm('Are you sure you want to change ' + this.appConstant.selectedHeaderProgramText + ' to ' + name + ' program? Any unsaved changes will be lost.', (result: any) => {
        if (result) {
          this.appConstant.logInAsProgramContext = this.appConstant.userDetail.roleContext == this.appConstant.roleContext.Admin;
          this.appConstant.selectedHeaderProgramText = name;
          var data = { logInAsProgramContext: this.appConstant.logInAsProgramContext, programId: programId };
          localStorage.setItem('logInAsProgramContext', JSON.stringify(data));
          if (this._router && this._router.url == "/dashboard") {
            this.appConstant.ShowAdminDashboard = true;
            setTimeout(() => {
              this.appConstant.ShowAdminDashboard = this.appConstant.userDetail.roleContext == this.appConstant.roleContext.Admin && this.appConstant.logInAsProgramContext == false;
            }, 100);
          }
          this.pageOnload();
        }
      });
    }
  }
  getAppSettings() {
    this.appConstant.mimsAppSettings = [];
    this._siteLayoutService.getAppsettings()
      .pipe(
      finalize(() => {
        this._loaderService.display(false);
      }))
      .subscribe(
        (res: any) => {
          this.appConstant.mimsAppSettings = res.data;

          if(this.appConstant.getAppSettingByParameter('ProductDecimalPlaces') !== undefined)
          {
            this.appConstant.mimsProductDecimalPlaces = this.appConstant.getAppSettingByParameter('ProductDecimalPlaces');
          }
          else
          {
            this.appConstant.mimsProductDecimalPlaces = '2';
          }

          if(this.appConstant.getAppSettingByParameter('MarkerDecimalPlaces') !== undefined)
          {
            this.appConstant.mimsMarkerDecimalPlaces = this.appConstant.getAppSettingByParameter('MarkerDecimalPlaces');
          }
          else
          {
            this.appConstant.mimsMarkerDecimalPlaces = '2';
          }

        },
        (error: any) => {
          console.log('error', error);
        }
      );
  };

}
